import { Navigate } from "react-router-dom";
import { useAppSelector } from "../../redux/hooks";
import { ReactNode } from "react";

export const TwoFaProtected = ({ children }: { children: ReactNode }) => {
  const { adminProfile } = useAppSelector((state) => state.auth);

  if (!adminProfile) {
    return <Navigate to="/login" replace />;
  }

  return children;
};
